import AllProductFlavorProfileIntensities from './AllProductFlavorProfileIntensities';
export default AllProductFlavorProfileIntensities;
